/* eslint-disable */
export function productDeliveryInfo() {
    // default delivery internal until we have real ones
    return {
        dimension17: '3-7',
    }
}
